import { useEffect, useState } from "react";

export default function useIdleTimer(maxIdleTime) {
  const [isIdle, setIsIdle] = useState(false);

  useEffect(() => {
    let timeoutId = null;
    const events = ["mousemove"];

    function startTimer() {
      stopTimer();
      timeoutId = setTimeout(() => {
        setIsIdle(true);
      }, maxIdleTime);
    }

    function stopTimer() {
      if (timeoutId) clearTimeout(timeoutId);
    }

    for (let i in events) {
      window.addEventListener(events[i], startTimer);
    }

    return function () {
      for (let i in events) {
        window.removeEventListener(events[i], stopTimer);
      }
    };
  }, [maxIdleTime]);

  return isIdle;
}
